export const PROBLEM_JSON_ERROR_CODES = {
  INVALID_JSON: 'invalidJson',
  EMPTY_JSON: 'emptyJson',
  NO_PLAN: 'noPlan',
  NO_JOBS: 'noJobs',
  NO_FLEET: 'noFleet',
} as const;

export type ProblemJsonErrorCode =
  (typeof PROBLEM_JSON_ERROR_CODES)[keyof typeof PROBLEM_JSON_ERROR_CODES];

export type ProblemJsonValidation = {
  json: Record<string, unknown> | null;
  errorCode: ProblemJsonErrorCode | null;
};

export const validateProblemJson = (value: string | Record<string, unknown>): ProblemJsonValidation => {
  let json: unknown = value;

  if (typeof value === 'string') {
    try {
      json = JSON.parse(value);
    } catch {
      return { json: null, errorCode: PROBLEM_JSON_ERROR_CODES.INVALID_JSON };
    }
  }

  if (!json || typeof json !== 'object' || Array.isArray(json)) {
    return { json: null, errorCode: PROBLEM_JSON_ERROR_CODES.INVALID_JSON };
  }

  const problem = json as Record<string, unknown>;
  if (Object.keys(problem).length === 0) {
    return { json: null, errorCode: PROBLEM_JSON_ERROR_CODES.EMPTY_JSON };
  }
  if (!problem.plan || typeof problem.plan !== 'object' || Array.isArray(problem.plan)) {
    return { json: null, errorCode: PROBLEM_JSON_ERROR_CODES.NO_PLAN };
  }
  if (!Array.isArray((problem.plan as Record<string, unknown>).jobs)) {
    return { json: null, errorCode: PROBLEM_JSON_ERROR_CODES.NO_JOBS };
  }
  if (!problem.fleet || typeof problem.fleet !== 'object' || Array.isArray(problem.fleet)) {
    return { json: null, errorCode: PROBLEM_JSON_ERROR_CODES.NO_FLEET };
  }

  return { json: problem, errorCode: null };
};
